/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';

import { appConfig } from './app/app.config';
import { App } from './app/app';
import localeIt from '@angular/common/locales/it';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
registerLocaleData(localeIt);
